import { gql } from "@apollo/client";

export const CLASSROOMS_FOR_STUDENTS=gql`
query getAllClassrooms($limit: Int, $offset: Int, $orderBy: [ClassroomsOrderBy!], $searchInput: String! = "%") {
  allClassrooms(
    first: $limit
    offset: $offset
    orderBy: $orderBy
    condition: {deletedAt: null}
    filter: {studentClassroomsByCId: {some: {studentBySId: {userByUId: {uFullName: {likeInsensitive: $searchInput}}}, isActive: {equalTo: true}}}, studentClassroomsByCIdExist: true}
  ) {
    nodes {
      cCode
      cId
      cName
      cStudentsCount
      classroomSubjectsByCId {
        nodes {
          subjectBySjId {
            sjName
          }
        }
      }
      studentClassroomsByCId(
        filter: {deletedAt: {isNull: true}, isActive: {equalTo: true}}
      ) {
        nodes {
          sId
          studentBySId {
            userByUId {
              uFullName
            }
          }
        }
        totalCount
      }
    }
    totalCount
  }
  allStudentClassrooms(
    filter: {isActive: {equalTo: true}, deletedAt: {isNull: true}, classroomByCId: {deletedAt: {isNull: true}}, studentBySId: {userByUId: {uFullName: {likeInsensitive: $searchInput}}}}
  ) {
    totalCount
  }
}`;

export const GET_STUDENTS_BY_CLASSROOM = gql`
query studentList($cId: UUID!, $limit: Int = null, $offset: Int = null, $searchInput: String = "%") {
  allStudents(
    filter: {studentClassroomsBySId: {some: {classroomByCId: {cId: {equalTo: $cId}, deletedAt: {isNull: true}}, isActive: {equalTo: true}, studentBySId: {deletedAt: {isNull: true}}}}, studentClassroomsBySIdExist: true, userByUId: {uFullName: {likeInsensitive: $searchInput}, deletedAt: {isNull: true}}}
    orderBy: USER_BY_U_ID__U_FULL_NAME_ASC
    first: $limit
    offset: $offset
  ) {
    nodes {
      sId
      sAvatarUrl
      userByUId {
        uFullName
        uPhoneNumber
        uUserName
        uUserPassword
        uEmailId
      }
    }
    totalCount
  }
}`;

export const STUDENTS_SWITCH_CLASS = gql`
mutation moveStudentsToAnotherClass($fromCid: String!, $toCid: String!, $sIds: [String!]!) {
  moveStudentsToAnotherClass(
    input: {fromCid: $fromCid, sIds: $sIds, toCid: $toCid}
  )
}`;

export const GET_CLASSROOM_LIST = gql`
query getAllClassrooms($limit: Int, $offset: Int, $orderBy: [ClassroomsOrderBy!], $cId: UUID!) {
  allClassrooms(
    first: $limit
    offset: $offset
    orderBy: $orderBy
    condition: {deletedAt: null}
    filter: {cId: {notEqualTo: $cId}}
  ) {
    nodes {
      cCode
      cId
      cName
      cStudentsCount
      classroomSubjectsByCId {
        nodes {
          subjectBySjId {
            sjName
          }
        }
      }
    }
    totalCount
  }
}`;

export const GET_STUDENTS_BY_ID = gql`
query getStudentBySId($sId: UUID!) {
  studentBySId(sId: $sId) {
    sId
    sAvatarUrl
    userByUId {
      uEmailId
      uFullName
      uPhoneNumber
      uUserName
      uUserPassword
      deletedAt
    }
  }
}`;

export const UPDATE_STUDENT_PROFILE = gql`
mutation updateStudentDetail($input: updateStudentInput) {
  updateStudentDetail(input: $input)
}`;

export const DELETE_STUDENT = gql`
mutation deleteStudentById($sId: String!) {
  deleteStudentById(sId: $sId)
}`;

export const EDIT_TEACHER = gql`
mutation editTeacher($avatarUrl: String, $password: String) {
  editVirtualTeacher(avatarUrl: $avatarUrl, password: $password)
}`;
